<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useAdminRolesStore } from '@/stores'
import type { Role } from '@/types/rbac'
import BaseDashboardPage from '@/components/base/BaseDashboardPage.vue'
import RolesList from './RolesList.vue'

const adminRolesStore = useAdminRolesStore()

const loading = ref(true)
const roles = ref<Role[]>([])

onMounted(async () => {
  loading.value = true
  roles.value = await adminRolesStore.fetchRoles()
  loading.value = false
})
</script>

<template>
  <BaseDashboardPage
    :title="$t('dashboard.admin.roles.title')"
    :subtitle="$t('dashboard.admin.roles.subtitle')"
    icon="mdi-shield-account"
    icon-color="purple"
  >
    <!-- Loading State -->
    <div v-if="loading" class="loading-state">
      <v-progress-circular indeterminate color="primary" size="48" />
      <p>{{ $t('dashboard.admin.roles.loading') }}</p>
    </div>

    <!-- Content -->
    <RolesList v-else :roles="roles" />
  </BaseDashboardPage>
</template>

<style lang="scss" scoped>
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px 16px;
  color: rgba(200, 218, 255, 0.6);

  p {
    font-size: 0.9rem;
    margin: 0;
  }
}
</style>
